import Vue from 'vue'
import Router from 'vue-router'
import TeamDashboard from '@/components/team/TeamDashboard.vue'
import authenticate from '@/middleware/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/team',
      name: 'teams',
      component: () => import(/* webpackChunkName: "team" */ './views/Team.vue'),
      children: [
        { path: '/', component: TeamDashboard }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },
})

router.beforeEach(authenticate)

export default router
